// File: accreditation.js
// Import Cumulo
import Cumulo from '../modules/cumulo.js';
import tbxHandleExpanders from "../sections/expanders.js";

class AccreditationRenderer extends Cumulo {
    onEnter() {
		tbxHandleExpanders();
    }
}

// Don`t forget to export your renderer
export default AccreditationRenderer;